<template>
  <div>
    <v-card>
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách"
          v-model="table.searchText"
        ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="table.headers"
          :search="table.searchText"
          :items="datasourceFiltered"
          :rows-per-page-items="[10,20,50,100]"
          :loading="isLoading"
          disable-initial-sort
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-icon color="orange">{{ getIcon(props.item.icon) }}</v-icon>
            </td>
            <td>
              <div class="content">
                <h5>{{ props.item.title }}</h5>
                <span>{{ props.item.content }}</span>
              </div>
            </td>
            <td>{{ getDate(props.item.createDate) }}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as DateTimeUtil from '@/utils/datetime';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      table: {
        searchText: '',
        headers: [
          {
            text: '#',
            value: 'icon'
          },
          {
            text: 'Nội dung',
            value: 'content'
          },
          {
            text: 'Thời gian',
            value: 'time'
          }
        ]
      },
      filter: 'all',
      datasourceFiltered: this.datasource
    };
  },
  watch: {
    datasource () {
      this.datasourceFiltered = this.datasource;
    }
  },
  methods: {
    getType (type) {
      return type === 'warning' ? 'Cảnh báo' : 'Tin tức';
    },
    getDate (date) {
      return DateTimeUtil.convertSecondToRelativeTime(date);
    },
    getIcon (icon) {
      let result = 'warning';
      if (icon) {
        switch (icon.toLowerCase()) {
          case 'lock':
            result = 'lock';
            break;
          case 'unlock':
            result = 'lock_open';
            break;
          case 'moving':
            result = 'near_me';
            break;
          case 'batalrm':
            result = 'battery_alert';
            break;
          case 'powercut':
          case 'turnon':
          case 'turnoff':
            result = 'power_settings_new';
            break;
          case 'connectionlost':
            result = 'signal_cellular_connected_no_internet_2_bar';
            break;
          case 'overspeed':
            result = 'network_check';
            break;
          case 'idle':
            result = 'local_parking';
            break;
          case 'illegalaccon':
            result = 'vpn_key';
            break;
          case 'vibration':
            result = 'vibration';
            break;
          case 'movein':
            result = 'input';
            break;
          case 'moveout':
            result = 'subdirectory_arrow_right';
            break;
          case 'news':
            result = 'email';
            break;
          case 'maintenance':
            result = 'build';
            break;
        }
      }
      return result;
    }
  }
};
</script>
<style scoped>
.content {
  padding: 8px 0px 8px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/notification/components/List.vue